export const BLANK_BARN = {
  id: null,
  typeId: null,
  amount: null,
};

export const BLANK_BEDDING = {
  id: null,
  typeId: null,
  amount: null,
};

export const BLANK_PESTICIDE = () => ({
  activeIngredient: null,
  key: Date.now(),
});

export const BLANK_PRACTICE = () => ({
  practiceType: null,
  practiceId: null,
  key: Date.now(),
});
export const BLANK_MANURE_STORAGE = {
  id: null,
  typeId: null,
  amount: null,
};
export const BLANK_PURCHASED_FEED = {
  id: null,
  typeId: null,
  amount: null,
  methaneReducingFeedId: null,
};
export const BLANK_PRODUCT = () => ({
  fertilizerType: null,
  fertilizerId: null,
  nValue: null,
  amount: null,
  applicationType: null,
  selfProduced: false,
  key: Date.now(),
});

export const DEADLINE_PERIOD = 14;
export const GRACE_PERIOD = 6;
export const LATE_PERIOD = GRACE_PERIOD; // This might become different from the grace period in the future
export const CUT_OFF_DAYTIME = "12-06T23:59:59";
export const SUBMISSION_START_DAYTIME = "11-01T00:00:00";
export const SUBMISSION_END_DAYTIME = "11-30T23:59:59";
export const ADMIN_VERIFICATION_DEADLINE = "08-16T23:59:59";

export const VESTING_PERCENTAGE = 0.25;
export const VESTING_YEARS = 5;

export const MODULE_COUNT = 5;

export enum MODULE_ACCESS {
  NONE = "NONE",
  LIMITED = "LIMITED",
  UNLIMITED = "UNLIMITED",
  ALL = "ALL",
}

export const CROPS_SCHEMA = {
  biodiversityBenifits: { de: [], en: [], pl: [] },
  enabled: true,
  id: "",
  name: { de: "", en: "", pl: "" },
  neutral: { de: false, en: false, pl: false },
  onlyVisibleToAdmins: false,
  recommendSplit: null,
  residue: { de: 0, en: 0, pl: 0 },
  synonyms: { de: [], en: [], pl: [] },
  isMainCrop: false,
  isCatchCrop: false,
  isUndersowing: false,
  isGrassland: false,
  isPerennial: false,
  isWinterCrop: false,
  isHarvested: false,
  isLegume: false,
  recommendSideCrop: false,
};

export const TILLAGE_SEEDING_SCHEMA = {
  id: "",
  name: { de: "", en: "", pl: "" },
  dieselUsage: { de: 0, en: 0, pl: 0 },
  enabled: true,
  onlyVisibleToAdmins: false,
  recommendSplit: null,
  synonyms: { de: [], en: [], pl: [] },
};

export const FERTILIZERS_APPLICATION_SCHEMA = {
  id: "",
  name: { de: "", en: "", pl: "" },
  manureMultiplier: { de: 0, en: 0, pl: 0 },
  dungMultiplier: { de: 0, en: 0, pl: 0 },
  enabled: true,
  synonyms: { de: [], en: [], pl: [] },
};

export const FERTILIZERS_APPLICATION_MINERALS_SCHEMA = {
  id: "",
  name: { de: "", en: "", pl: "" },
  co2Value: { de: 0, en: 0, pl: 0 },
  ammonia: { de: 0, en: 0, pl: 0 },
  nValue: { de: 0, en: 0, pl: 0 },
  enabled: true,
  synonyms: { de: [], en: [], pl: [] },
};

export const FERTILIZERS_APPLICATION_ORGANICS_SCHEMA = {
  id: "",
  name: { de: "", en: "", pl: "" },
  co2Value: { de: 0, en: 0, pl: 0 },
  tanPart: { de: 0, en: 0, pl: 0 },
  mineralEquivalent: { de: 0, en: 0, pl: 0 },
  nValue: { de: 0, en: 0, pl: 0 },
  type: "",
  enabled: true,
  synonyms: { de: [], en: [], pl: [] },
};

export enum MODULE_SUBMISSION_STEP_KEY {
  CROPS = "crops",
  HARVEST = "harvest",
  FERTILISER = "fertilizer",
  TILLAGE = "tillage_seeding",
  PESTICIDE = "pesticides",
  SUBMIT = "submit",
  SUCCESS = "success",
}

export const MODULE_SUBMISSION_SCHEMA = [
  {
    item: MODULE_SUBMISSION_STEP_KEY.CROPS,
    textKey: MODULE_SUBMISSION_STEP_KEY.CROPS,
    show: false,
    completed: false,
  },
  {
    item: MODULE_SUBMISSION_STEP_KEY.HARVEST,
    textKey: MODULE_SUBMISSION_STEP_KEY.HARVEST,
    show: false,
    completed: false,
  },
  {
    item: MODULE_SUBMISSION_STEP_KEY.FERTILISER,
    textKey: MODULE_SUBMISSION_STEP_KEY.FERTILISER,
    show: false,
    completed: false,
  },
  {
    item: MODULE_SUBMISSION_STEP_KEY.TILLAGE,
    textKey: MODULE_SUBMISSION_STEP_KEY.TILLAGE,
    show: false,
    completed: false,
  },
  {
    item: MODULE_SUBMISSION_STEP_KEY.PESTICIDE,
    textKey: MODULE_SUBMISSION_STEP_KEY.PESTICIDE,
    show: false,
    completed: false,
  },
  {
    item: MODULE_SUBMISSION_STEP_KEY.SUBMIT,
    textKey: MODULE_SUBMISSION_STEP_KEY.SUBMIT,
    show: true,
    completed: false,
  },
];
